export default __webpack_public_path__ + "static/media/home-s1-support.a0565e4c.webp";